import React from 'react';
import { Link, Routes, Route, useLocation } from 'react-router-dom';
import Component from '../../components/Component';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Tab, Tabs, Typography } from '@mui/material';
import ArticleList from './ArticleList';
import ArticleEditor from './ArticleEditor';
import SourceSites from './SourceSites';

function curatedTab(path) {
  if (path.startsWith('/admin/curated-articles/sources')) return 'sources';
  return 'articles';
}

function CuratedArticles() {
  const location = useLocation();
  const tabValue = curatedTab(location.pathname);
  const isEditor =
    location.pathname.endsWith('/new') ||
    /^\/admin\/curated-articles\/\d+/.test(location.pathname);

  return (
    <Component>
      <div className="page-body">
        <div className="container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-sm-10 d-flex align-items-center">
                <IconButton
                  style={{ background: '#FFFFFF', marginRight: 8 }}
                  component={Link}
                  to="/"
                >
                  <ArrowBackIcon />
                </IconButton>
                <div>
                  <h3 style={{ margin: 0 }}>Curated Articles</h3>
                  <Typography variant="body2" color="text.secondary">
                    Merge 1–3 URLs → review → publish to Pulse (news + hot take). Not Discover.
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          {!isEditor && (
            <Tabs value={tabValue} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
              <Tab
                label="Articles"
                value="articles"
                component={Link}
                to="/admin/curated-articles"
              />
              <Tab
                label="Source sites"
                value="sources"
                component={Link}
                to="/admin/curated-articles/sources"
              />
            </Tabs>
          )}

          <Routes>
            <Route index element={<ArticleList />} />
            <Route path="sources" element={<SourceSites />} />
            <Route path="new" element={<ArticleEditor />} />
            <Route path=":id" element={<ArticleEditor />} />
          </Routes>
        </div>
      </div>
    </Component>
  );
}

export default CuratedArticles;
